import className from "classnames/bind";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

/**
 * Biểu đồ xu hướng điểm SEO trung bình qua các lần crawl (so crawls.avg_score).
 * Vẽ bằng SVG thuần để không thêm dependency chart.
 */
function ScoreTrendChart({crawls = []}) {

	// Chỉ lấy các crawl đã xong, sắp theo thời gian tăng dần.
	const done = crawls
		.filter((c) => c.status === 'done')
		.slice()
		.reverse();

	if (done.length < 1) {
		return (
			<div className={cn('trend')}>
				<div className={cn('trendEmpty')}>Chưa có dữ liệu điểm. Chạy crawl để bắt đầu theo dõi xu hướng.</div>
			</div>
		);
	}

	const W = 600;
	const H = 160;
	const P = 28;
	const innerW = W - P * 2;
	const innerH = H - P * 2;

	const n = done.length;
	const x = (i) => (n === 1 ? W / 2 : P + (innerW * i) / (n - 1));
	const y = (v) => P + innerH - (innerH * Math.max(0, Math.min(100, v))) / 100;

	const points = done.map((c, i) => `${x(i)},${y(Number(c.avg_score || 0))}`).join(' ');

	return (
		<div className={cn('trend')}>
			<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
				{/* lưới ngang 0/50/100 */}
				{[0, 50, 100].map((g) => (
					<g key={g}>
						<line x1={P} y1={y(g)} x2={W - P} y2={y(g)} stroke="#eef0f4" strokeWidth="1" />
						<text x={4} y={y(g) + 4} fontSize="10" fill="#9ca3af">{g}</text>
					</g>
				))}

				{n > 1 && (
					<polyline points={points} fill="none" stroke="#4f46e5" strokeWidth="2" />
				)}

				{done.map((c, i) => (
					<g key={c.id}>
						<circle cx={x(i)} cy={y(Number(c.avg_score || 0))} r="4" fill="#4f46e5" />
						<text x={x(i)} y={y(Number(c.avg_score || 0)) - 10} fontSize="11" fill="#374151" textAnchor="middle">
							{c.avg_score}
						</text>
					</g>
				))}
			</svg>
		</div>
	);
}

export default ScoreTrendChart;
